import Swal from 'sweetalert2';
import i18n from '@/i18n';

/** Escape HTML and turn newlines into <br> so multiline messages render in Swal. */
const toSwalHtml = (message) =>
	String(message ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/\n/g, '<br>');

export const handleError = (error, clearError) => {
    if (error) {
      Swal.fire({ title: i18n.t('notifications.errorTitle'), html: toSwalHtml(error), icon: 'error' }).then(() => {
        clearError();
      });
    }
};

export const handleSuccess = (message) => {
    if (message) { Swal.fire({ title: i18n.t('notifications.successTitle'), html: toSwalHtml(message), icon: 'success' });}
};

export const showError = (message, cb = null) => { Swal.fire({ title: i18n.t('notifications.errorTitle'), html: toSwalHtml(message), icon: 'error'}); if(cb) cb(); };
export const showSuccess = (message, cb = null) => { Swal.fire({ title: i18n.t('notifications.successTitle'), html: toSwalHtml(message), icon: 'success'}); if(cb) cb();};

export const handleConfirm = async (message, onConfirm) => {
    const result = await Swal.fire({
        title: 'Confirm',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
    });

    if (result.isConfirmed && typeof onConfirm === 'function') {
        await onConfirm();
    }

    return result;
};
